import TabPage from '@/components/TabPage';

export default function Inventory() {
  return <TabPage chartFullKeys={['trend']} />;
}
